import React from "react";

// components

import CardTable from "components/Cards/CardTable";

export default function Pronosticos() {
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12 px-4">
          <CardTable />
        </div>
      </div>
    </>
  );
}
